import React from 'react';
import { FiCalendar } from 'react-icons/fi';
import { useBooking } from '../../context/BookingContext';
import './DateSelector.css';

const DateSelector = () => {
  const { booking, updateBooking } = useBooking();
  const today = new Date().toISOString().split('T')[0];

  const showReturn =
    booking.tripType === 'round_trip' ||
    (booking.tripType === 'outstation' && booking.rideMode === 'round_trip');
  const isOutstationRoundTrip =
    booking.tripType === 'outstation' && booking.rideMode === 'round_trip';

  const pickupDateTime = booking.date && booking.pickupTime
    ? `${booking.date}T${booking.pickupTime}`
    : '';
  const returnMin = isOutstationRoundTrip
    ? pickupDateTime || `${booking.date || today}T00:00`
    : booking.date || today;

  const updateDateTime = (value, dateKey, timeKey) => {
    const [date, time] = value.split('T');
    updateBooking(dateKey, date || '');
    updateBooking(timeKey, time || '');
  };

  return (
    <div className="ds-grid">
      {booking.tripType === 'outstation' ? (
        <div className="ds-field">
          <label className="ds-label">Pickup Date & Time</label>
          <div className="ds-input">
            <FiCalendar className="ds-icon" />
            <input
              type="datetime-local"
              min={`${today}T00:00`}
              value={pickupDateTime}
              onChange={(e) => updateDateTime(e.target.value, 'date', 'pickupTime')}
            />
          </div>
        </div>
      ) : (
        <div className="ds-field">
          <label className="ds-label">
            {booking.tripType === 'instant' ? 'Pickup Date & Time' : 'Date & Time'}
          </label>
          <div className="ds-input">
            <FiCalendar className="ds-icon" />
            <input
              type="datetime-local"
              min={`${today}T00:00`}
              value={pickupDateTime}
              onChange={(e) => updateDateTime(e.target.value, 'date', 'pickupTime')}
            />
          </div>
        </div>
      )}

      {showReturn && (
        <div className="ds-field">
          <label className="ds-label">
            {isOutstationRoundTrip ? 'Return Date & Time' : 'Return Date'}
          </label>
          <div className="ds-input">
            <FiCalendar className="ds-icon" />
            <input
              type={isOutstationRoundTrip ? 'datetime-local' : 'date'}
              min={returnMin}
              value={booking.returnDate}
              onChange={(e) => updateBooking('returnDate', e.target.value)}
            />
          </div>
        </div>
      )}

    </div>
  );
};

export default DateSelector;